// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"error_Wrapper__6BAz9","Icon":"error_Icon__xwWCd","Text":"error_Text__bfuoj"};